module.exports = __webpack_public_path__ + "img/6.54965fb8.png";